/* ═══════════════════════════════════════════════════════════════
   SWINDLE KING — cart bridge for SKC main PDP button, quick add + sticky ATC
   The add itself is done by the theme's own <product-form-component>
   (assets/product-form.js → /cart/add.js). This file only:
     1. opens the cart drawer after a successful SKC add, even if
        "Auto-open cart drawer" is off in Theme settings, and
     2. closes the quick-add size panel after the add.
   Loaded as a module, so the browser runs it once per page no matter
   how many cards include it.
   ═══════════════════════════════════════════════════════════════ */
import { StandardEvents } from '@shopify/events';

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  const source = event.target;
  if (!(source instanceof Element) || !source.closest('[data-skc-cart-bridge]')) return;

  /* Main PDP button (sections/skc-product.liquid): lock while the add is in flight, flash "Added". */
  const mainBtn = /** @type {HTMLButtonElement | null} */ (source.querySelector('[data-skc-atc]'));
  const mainSpan = mainBtn?.querySelector('span');
  const idleText = mainBtn?.getAttribute('data-txt-add') || 'Add to Cart';
  if (mainBtn) { mainBtn.disabled = true; if (mainSpan) mainSpan.textContent = 'Adding…'; }
  const restore = (text) => {
    if (!mainBtn) return;
    if (mainSpan) mainSpan.textContent = text;
    setTimeout(() => { mainBtn.disabled = false; if (mainSpan) mainSpan.textContent = idleText; }, text === idleText ? 0 : 1600);
  };

  event.promise
    ?.then(({ detail }) => {
      if (detail?.didError) { restore(idleText); return; }
      restore('Added ✓');
      source.closest('details.skc-qa')?.removeAttribute('open');
      const drawer = /** @type {any} */ (document.getElementById('cart-drawer'));
      if (drawer && !drawer.isOpen && typeof drawer.open === 'function') drawer.open();
    })
    .catch(() => restore(idleText));
});
